module.exports = __webpack_public_path__ + "static/comercial-trash-service-single-89fe0db9f90ad2023a1130bbc8f6e9b2.jpg";